module.exports = __webpack_public_path__ + "static/media/subclase.3b2f0cde.svg";